import { Home } from '@pages/Home';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const editaisSearchSchema = z.object({
  numeroEdital: z.string().optional(),
  modalidadeId: z.number().optional(),
  objetoId: z.string().optional(),
  orgaoPromotorId: z.string().optional(),
  uf: z.string().optional(),
  EditaisEncerrados: z.string().optional(),
});

export const Route = createFileRoute('/')({
  component: Home, // Sempre carrega a Home
  validateSearch: (search) => editaisSearchSchema.parse(search ?? {}),
});
